import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ButtonBase } from '@mui/material';
import { format as dateFormat } from 'date-fns';
import React, { ChangeEvent, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { TimeDisplay } from '../../../../../navigation/ToggleUTCLocal/TimeDisplays/TimeDisplay';
import { localeToDateFormat } from '../../../../../time/time.utils';
import {
    StyledDataBox,
    StyledDateDataBox,
    StyledEndTimeContainer,
    StyledFlightDataContainer,
    StyledTitleDataBox,
} from './FlightsInformation.style';

export function DeleteTimePicker({
    deleteTime,
    deleteTimeString,
    minDeleteTime,
    locale,
    timezone,
    onChange,
}: {
    deleteTime: number | undefined;
    deleteTimeString: string | null;
    minDeleteTime: string | null;
    locale: string;
    timezone: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}) {
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <StyledFlightDataContainer>
            <StyledDateDataBox>
                {deleteTime ? dateFormat(deleteTime, localeToDateFormat[locale]) : <>&nbsp;</>}
            </StyledDateDataBox>
            <StyledEndTimeContainer>
                <StyledTitleDataBox>
                    <FormattedMessage id={'turnaround.popin.endTime'} />
                </StyledTitleDataBox>
                <ButtonBase onClick={() => inputRef.current?.showPicker()} sx={{ position: 'relative' }}>
                    {deleteTime ? (
                        <StyledDataBox>
                            <TimeDisplay time={deleteTime} blink={false} timezone={timezone} undisplayedZone={true} />
                        </StyledDataBox>
                    ) : (
                        <CalendarMonthIcon sx={{ color: '#006ebb' }} />
                    )}
                    <input
                        ref={inputRef}
                        type="datetime-local"
                        value={deleteTimeString || ''}
                        onChange={onChange}
                        name="turnaround.arrivalFlight.deleteTime"
                        min={minDeleteTime || undefined}
                        style={{
                            position: 'absolute',
                            opacity: 0,
                            width: 0,
                            height: 0,
                            overflow: 'hidden',
                            pointerEvents: 'none',
                        }}
                    />
                </ButtonBase>
            </StyledEndTimeContainer>
        </StyledFlightDataContainer>
    );
}
